import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {switchMap} from "rxjs";
import {map} from "rxjs/operators";
import {CategoryService} from "../../main/pages/category.service";

import * as CategoriesActions from './../actions/categories.actions';
import { IGetCategoriesItemDto } from "app/main/pages/categories.dto";

@Injectable({
    providedIn:'root'
})
export class CategoriesEffects{
    constructor(
        private _actions$: Actions,
        private _categoryService: CategoryService
    ) {}

    fetchCategories$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(CategoriesActions.fetchCategories),
            switchMap(() => {
                return this._categoryService.fetchCategories('all')
                    .pipe(
                        map((categories: IGetCategoriesItemDto[]) => CategoriesActions.fetchCategoriesSuccess({categories}))
                    )
            })
        )
    });
}